// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-banner-swiper{width:100%;display:block;--swiper-pagination-color: #f68a33}.main-banner-swiper .swiper-prev-btn::after,.main-banner-swiper .swiper-next-btn::after{color:#fff}.main-banner-swiper .swiper-prev-btn-ls,.main-banner-swiper .swiper-next-btn-ls{top:35%}", ""]);
// Exports
module.exports = exports;
